{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2023                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSWEBStateManager;

{$I WEBLib.TMSWEBDefines.inc}

interface

uses
  Classes, WEBLib.TMSWEBCustomComponent, WEBLib.TMSWEBTypes,
  WEBLib.Forms, WEBLib.Controls, WEBLib.TMSWEBJSONWriter, WEBLib.TMSWEBPersistence
  {$IFDEF FMXLIB}
  ,FMX.Types
  {$ENDIF}
  ,TypInfo
  ;

type
  TTMSWEBCustomStateManager = class;

  TTMSWEBStateManagerItem = class(TCollectionItem)
  private
    FOwner: TTMSWEBCustomStateManager;
    FDefault: Boolean;
    FName: string;
    FContent: string;
    FDataPointer: Pointer;
    FDataBoolean: Boolean;
    FDataString: String;
    FDataObject: TObject;
    FDataInteger: NativeInt;
    procedure SetDefault(const Value: Boolean);
    function GetName: string;
  protected
    function GetDisplayName: string; override;
    function Manager: TTMSWEBCustomStateManager;
  public
    constructor Create(Collection: TCollection); override;
    procedure Assign(Source: TPersistent); override;
    destructor Destroy; override;
    procedure Load;

    property DataPointer: Pointer read FDataPointer write FDataPointer;
    property DataBoolean: Boolean read FDataBoolean write FDataBoolean;
    property DataObject: TObject read FDataObject write FDataObject;
    property DataString: String read FDataString write FDataString;
    property DataInteger: NativeInt read FDataInteger write FDataInteger;

  published
    property Name: string read GetName write FName;
    property Content: string read FContent write FContent;
    property &Default: Boolean read FDefault write SetDefault default False;
  end;

  {$IFDEF WEBLIB}
  TTMSWEBStateManagerItems = class(TTMSWEBOwnedCollection, ITMSWEBBaseListIO, ITMSWEBBasePersistenceIO)
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSWEBStateManagerItems = class({$IFDEF LCLLIB}specialize {$ENDIF}TTMSWEBOwnedCollection<TTMSWEBStateManagerItem>, ITMSWEBBaseListIO, ITMSWEBBasePersistenceIO)
  {$ENDIF}
  private
    FOwnerInterface: IInterface;
    FOwner: TTMSWEBCustomStateManager;
    function GetItemEx(Index: Integer): TTMSWEBStateManagerItem;
    procedure SetItemEx(Index: Integer; const Value: TTMSWEBStateManagerItem);
  protected
    function GetStateManagerStateClass: TCollectionItemClass; virtual;
    function ITMSWEBBaseListIO.GetItemClass = GetInterfaceItemClass;
    function CreateObject(const AClassName: string; const ABaseClass: TClass): TObject; virtual;
    function GetInterfaceItemClass: TClass; virtual;
    {$IFDEF LCLLIB}
    function _AddRef : longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
    function _Release : longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
    {$ELSE}
    function _AddRef: Integer; {$IFNDEF WEBLIB}stdcall;{$ENDIF}
    function _Release: Integer; {$IFNDEF WEBLIB}stdcall;{$ENDIF}
    {$ENDIF}
  public
    {$IFDEF LCLLIB}
    function QueryInterface({$IFDEF FPC_HAS_CONSTREF}constref{$ELSE}const{$ENDIF} iid : tguid;out obj) : longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
    {$ELSE}
    function QueryInterface(const IID: TGUID; out Obj): HResult; virtual; {$IFNDEF WEBLIB}stdcall;{$ENDIF}
    {$ENDIF}
    constructor Create(AOwner: TTMSWEBCustomStateManager);
    function Add: TTMSWEBStateManagerItem;{$IFDEF WEBLIB}reintroduce;{$ENDIF}
    function Insert(index: Integer): TTMSWEBStateManagerItem;{$IFDEF WEBLIB}reintroduce;{$ENDIF}
    property Items[Index: Integer]: TTMSWEBStateManagerItem read GetItemEx write SetItemEx; default;
  end;

  {$IFDEF FMXLIB}
  TTMSWEBStateManagerControl = TFmxObject;
  {$ELSE}
  TTMSWEBStateManagerControl = TControl;
  {$ENDIF}

  TTMSWEBStateManagerLoadStateCustomCallback = {$IFNDEF LCLLIB}reference to {$ENDIF}procedure(AState: TTMSWEBStateManagerItem; var ALoad: Boolean){$IFDEF LCLLIB} of object{$ENDIF};
  TTMSWEBStateManagerLoadStateCustomEvent = procedure(Sender: TObject; AState: TTMSWEBStateManagerItem; var ALoad: Boolean) of object;

  TTMSWEBStateManagerBeforeLoadStateEvent = procedure(Sender: TObject; AState: TTMSWEBStateManagerItem; var ACanLoad: Boolean) of object;
  TTMSWEBStateManagerAfterLoadStateEvent = procedure(Sender: TObject; AState: TTMSWEBStateManagerItem) of object;

  TTMSWEBStateManagerBeforeLoadControlStateEvent = procedure(Sender: TObject; AState: TTMSWEBStateManagerItem; AControl: TTMSWEBStateManagerControl; var AValue: string; var ACanLoad: Boolean) of object;
  TTMSWEBStateManagerAfterLoadControlStateEvent = procedure(Sender: TObject; AState: TTMSWEBStateManagerItem; AControl: TTMSWEBStateManagerControl; AValue: string) of object;

  TTMSWEBCustomStateManager = class(TTMSWEBCustomComponent)
  private
    FUpdateCount: Integer;
    FActiveState: Integer;
    FStates: TTMSWEBStateManagerItems;
    FControl: TTMSWEBStateManagerControl;
    FOnLoadStateCustom: TTMSWEBStateManagerLoadStateCustomEvent;
    FAutoSave: Boolean;
    FOnAfterLoadState: TTMSWEBStateManagerAfterLoadStateEvent;
    FOnBeforeLoadState: TTMSWEBStateManagerBeforeLoadStateEvent;
    FOnAfterLoadControlState: TTMSWEBStateManagerAfterLoadControlStateEvent;
    FOnBeforeLoadControlState: TTMSWEBStateManagerBeforeLoadControlStateEvent;
    procedure SetStates(const Value: TTMSWEBStateManagerItems);
    procedure SetActiveState(const Value: Integer);
    procedure SetControl(const Value: TTMSWEBStateManagerControl);
  protected
    function GetInstance: NativeUInt; override;
    function GenerateContent: string;
    function CanPersist(AControl: TTMSWEBStateManagerControl): Boolean;
    function GetControlCount(AControl: TTMSWEBStateManagerControl): Integer;
    function GetControls(AControl: TTMSWEBStateManagerControl; AIndex: Integer): TTMSWEBStateManagerControl;
    function CreateStatesCollection: TTMSWEBStateManagerItems; virtual;
    function FindControlByName(AName: string; ARootControl: TTMSWEBStateManagerControl = nil): TTMSWEBStateManagerControl;

    procedure ResetState; virtual;
    procedure BeforeAssignControl; virtual;
    procedure AfterAssignControl; virtual;
    procedure DoBeforeLoadState(AState: TTMSWEBStateManagerItem; var ACanLoad: Boolean); virtual;
    procedure DoAfterLoadState(AState: TTMSWEBStateManagerItem); virtual;
    procedure DoBeforeLoadControlState(AState: TTMSWEBStateManagerItem; AControl: TTMSWEBStateManagerControl; var AValue: string; var ACanLoad: Boolean); virtual;
    procedure DoAfterLoadControlState(AState: TTMSWEBStateManagerItem; AControl: TTMSWEBStateManagerControl; AValue: string); virtual;
    procedure BeforeLoadState(AState: TTMSWEBStateManagerItem); virtual;
    procedure InternalLoadState(AState: TTMSWEBStateManagerItem); virtual;
    procedure InternalSaveToState(AState: TTMSWEBStateManagerItem; ANew: Boolean); virtual;
    procedure InternalSetActiveState(AState: TTMSWEBStateManagerItem); virtual;

    procedure DoCanWrite(AObject: TObject; APropertyName: string; APropertyKind: TTypeKind; AWriter: TTMSWEBJSONWriter; var ACanWrite: Boolean);
    property States: TTMSWEBStateManagerItems read FStates write SetStates;
    property Control: TTMSWEBStateManagerControl read FControl write SetControl;
    property OnLoadStateCustom: TTMSWEBStateManagerLoadStateCustomEvent read FOnLoadStateCustom write FOnLoadStateCustom;
    property OnBeforeLoadState: TTMSWEBStateManagerBeforeLoadStateEvent read FOnBeforeLoadState write FOnBeforeLoadState;
    property OnAfterLoadState: TTMSWEBStateManagerAfterLoadStateEvent read FOnAfterLoadState write FOnAfterLoadState;
    property OnBeforeLoadControlState: TTMSWEBStateManagerBeforeLoadControlStateEvent read FOnBeforeLoadControlState write FOnBeforeLoadControlState;
    property OnAfterLoadControlState: TTMSWEBStateManagerAfterLoadControlStateEvent read FOnAfterLoadControlState write FOnAfterLoadControlState;
    property ActiveState: Integer read FActiveState write SetActiveState default -1;
    property AutoSave: Boolean read FAutoSave write FAutoSave default True;
  public
    constructor Create; reintroduce; overload; virtual;
    constructor Create(AOwner: TComponent); overload; override;
    destructor Destroy; override;
    procedure Assign(Source: TPersistent); override;
    procedure BeginUpdate; override;
    procedure EndUpdate; override;
    procedure Loaded; override;

    procedure SaveToState(AState: TTMSWEBStateManagerItem); overload; virtual;
    procedure SaveToState(AIndex: Integer); overload; virtual;
    procedure SaveToState(AName: string); overload; virtual;
    procedure LoadStateByName(AName: string); overload; virtual;
    procedure LoadStateByIndex(AIndex: Integer); overload; virtual;
    procedure LoadStateCustom(ACallBack: TTMSWEBStateManagerLoadStateCustomCallback = nil);
    procedure Optimize; virtual;

    function FindConflicts(AConflictedControlNames: TStrings): Boolean; virtual;

    function GetDefaultState: TTMSWEBStateManagerItem; virtual;

    function FindStateByName(AName: string): TTMSWEBStateManagerItem; virtual;
  end;

implementation

uses
  WEBLib.TMSWEBGraphics, SysUtils, Math, Types, WEBLib.TMSWEBUtils,
  WEBLib.TMSWEBCustomControl, WEBLib.TMSWEBGraphicsTypes, WEBLib.Graphics
  {$IFDEF WEBLIB}
  ,WEBLib.JSON, Generics.Collections
  {$ENDIF}
  {$IFDEF FMXLIB}
  ,JSON, Generics.Collections
  {$ENDIF}
  {$IFDEF VCLLIB}
  ,JSON, Generics.Collections
  {$ENDIF}
  {$IFDEF LCLLIB}
  ,fpjson, fgl
  {$ENDIF}
  ;

//{$R 'TMSWEBState.res'}

type
  TTMSWEBStateManagerRootJSONValue = class
  private
    FState: TTMSWEBStateManagerItem;
    FValue: TJSONValue;
  public
    constructor Create(AState: TTMSWEBStateManagerItem; AValue: TJSONValue);
    destructor Destroy; override;
  end;

  TTMSWEBStateManagerJSONValue = class;

  TTMSWEBStateManagerJSONValueList = TObjectList<TTMSWEBStateManagerJSONValue>;

  TTMSWEBStateManagerJSONValueArray = array of TJSONValue;

  TTMSWEBStateManagerJSONValue = class
  private
    FValue: TJSONValue;
    FParentValue: TJSONValue;
    FValueName: string;
  public
    constructor Create(AParentValue, AValue: TJSONValue; AValueName: string);
    destructor Destroy; override;
  end;

  TTMSWEBStateManagerRootJSONValueList = TObjectList<TTMSWEBStateManagerRootJSONValue>;

  {$IFDEF FMXLIB}
  TCustomFormHelper = class helper for TCustomForm
  private
    function GetControlCount: Integer;
    function GetControls(AIndex: Integer): TTMSWEBStateManagerControl;
  public
    property ControlCount: Integer read GetControlCount;
    property Controls[Index: Integer]: TTMSWEBStateManagerControl read GetControls;
  end;
  {$ENDIF}

  {$IFDEF VCLLIB}
  TControlOpen = class(TWinControl);
  {$ENDIF}

{$IFDEF FMXLIB}

{ TCustomFormHelper }

function TCustomFormHelper.GetControls(AIndex: Integer): TTMSWEBStateManagerControl;
var
  c: TComponent;
begin
  Result := nil;
  c := Components[AIndex];
  if c is TTMSWEBStateManagerControl then
    Result := c as TTMSWEBStateManagerControl;
end;

function TCustomFormHelper.GetControlCount: Integer;
begin
  Result := ComponentCount;
end;

{$ENDIF}

{ TTMSWEBCustomStateManager }

procedure TTMSWEBCustomStateManager.AfterAssignControl;
begin

end;

procedure TTMSWEBCustomStateManager.Assign(Source: TPersistent);
begin
  if Source is TTMSWEBCustomStateManager then
  begin
    FStates.Assign((Source as TTMSWEBCustomStateManager).States);
    FControl := (Source as TTMSWEBCustomStateManager).Control;
    FAutoSave := (Source as TTMSWEBCustomStateManager).AutoSave;
    FActiveState := (Source as TTMSWEBCustomStateManager).ActiveState;
  end;
end;

procedure TTMSWEBCustomStateManager.BeforeAssignControl;
begin

end;

procedure TTMSWEBCustomStateManager.BeforeLoadState(
  AState: TTMSWEBStateManagerItem);
begin

end;

procedure TTMSWEBCustomStateManager.BeginUpdate;
begin
  inherited;
  Inc(FUpdateCount);
end;

constructor TTMSWEBCustomStateManager.Create;
begin
  Create(nil);
end;

procedure TTMSWEBCustomStateManager.DoAfterLoadControlState(
  AState: TTMSWEBStateManagerItem; AControl: TTMSWEBStateManagerControl;
  AValue: string);
begin
  if Assigned(OnAfterLoadControlState) then
    OnAfterLoadControlState(Self, AState, AControl, AValue);
end;

procedure TTMSWEBCustomStateManager.DoBeforeLoadControlState(
  AState: TTMSWEBStateManagerItem; AControl: TTMSWEBStateManagerControl;
  var AValue: string; var ACanLoad: Boolean);
begin
  if Assigned(OnBeforeLoadControlState) then
    OnBeforeLoadControlState(Self, AState, AControl, AValue, ACanLoad);
end;

procedure TTMSWEBCustomStateManager.DoAfterLoadState(
  AState: TTMSWEBStateManagerItem);
begin
  if Assigned(OnAfterLoadState) then
    OnAfterLoadState(Self, AState);
end;

procedure TTMSWEBCustomStateManager.DoBeforeLoadState(
  AState: TTMSWEBStateManagerItem; var ACanLoad: Boolean);
begin
  if Assigned(OnBeforeLoadState) then
    OnBeforeLoadState(Self, AState, ACanLoad);
end;

procedure TTMSWEBCustomStateManager.DoCanWrite(AObject: TObject;
  APropertyName: string; APropertyKind: TTypeKind; AWriter: TTMSWEBJSONWriter;
  var ACanWrite: Boolean);
begin
  ACanWrite := not (APropertyKind in [tkClassRef, tkPointer{$IFNDEF LCLLIB}, tkProcedure{$ENDIF}, tkMethod]);
end;

function TTMSWEBCustomStateManager.CanPersist(
  AControl: TTMSWEBStateManagerControl): Boolean;
begin
  Result := {$IFDEF FMXLIB}not (AControl is TStyleBook) and{$ENDIF}
            not (AControl is TTMSWEBCustomComponent);
end;

constructor TTMSWEBCustomStateManager.Create(AOwner: TComponent);
begin
  inherited;

  FStates := CreateStatesCollection;
  FActiveState := -1;
  FAutoSave := True;

  if Assigned(AOwner) and (AOwner is TTMSWEBStateManagerControl) and IsDesignTime then
  begin
    if AOwner is TTMSWEBStateManagerControl then
      Control := AOwner as TTMSWEBStateManagerControl;
  end;
end;

function TTMSWEBCustomStateManager.CreateStatesCollection: TTMSWEBStateManagerItems;
begin
  Result := TTMSWEBStateManagerItems.Create(Self);
end;

destructor TTMSWEBCustomStateManager.Destroy;
begin
  FStates.Free;
  inherited;
end;

procedure TTMSWEBCustomStateManager.EndUpdate;
begin
  inherited;
  Dec(FUpdateCount);
//  if FUpdateCount = 0 then
//    DoSomething;
end;

function TTMSWEBCustomStateManager.FindStateByName(
  AName: string): TTMSWEBStateManagerItem;
var
  I: Integer;
begin
  Result := nil;
  for I := 0 to States.Count - 1 do
  begin
    if UpperCase(States[I].Name) = UpperCase(AName) then
    begin
      Result := States[I];
      Break;
    end;
  end;
end;

function TTMSWEBCustomStateManager.FindConflicts(
  AConflictedControlNames: TStrings): Boolean;
var
  s: string;
  v, jv, jvv: TJSONValue;
  I, M: Integer;
  snm, nm: string;
  a: TJSONArray;
  c: TTMSWEBStateManagerControl;
  st: TTMSWEBStateManagerItem;
begin
  Result := False;
  for M := 0 to States.Count - 1 do
  begin
    st := States[M];
    s := st.Content;
    v := TTMSWEBUtils.ParseJSON(s);
    if Assigned(v) then
    begin
      try
        jv := TTMSWEBUtils.FindJSONValue(v, 'components');
        if Assigned(jv) and (jv is TJSONArray) then
        begin
          a := jv as TJSONArray;
          for I := 0 to TTMSWEBUtils.GetJSONArraySize(a) - 1 do
          begin
            jvv := TTMSWEBUtils.GetJSONArrayItem(a, I);
            if Assigned(jvv) and (jvv is TJSONObject) then
            begin
              nm := TTMSWEBUtils.GetJSONObjectName(jvv as TJSONObject, 0);
              c := FindControlByName(nm);
              if not Assigned(c) then
              begin
                Result := True;
                snm := st.Name;
                if AConflictedControlNames.Values[snm] = '' then
                  AConflictedControlNames.Values[snm] := nm
                else
                  AConflictedControlNames.Values[snm] := AConflictedControlNames.Values[snm] + ',' + nm;
              end;
            end;
          end;
        end;
      finally
        v.Free;
      end;
    end;
  end;
end;

function TTMSWEBCustomStateManager.FindControlByName(
  AName: string; ARootControl: TTMSWEBStateManagerControl = nil): TTMSWEBStateManagerControl;
var
  c: TTMSWEBStateManagerControl;

  function FindControl(AControl: TTMSWEBStateManagerControl): TTMSWEBStateManagerControl;
  var
    cn: string;
    ct: TComponent;
    I: Integer;
  begin
    Result := nil;
    if UpperCase(AControl.Name) = UpperCase(AName) then
    begin
      Result := AControl;
      Exit;
    end;


    for I := 0 to GetControlCount(AControl) - 1 do
    begin
      ct := GetControls(AControl, I);
      if Assigned(ct) and (ct is TTMSWEBStateManagerControl) and CanPersist(ct as TTMSWEBStateManagerControl) then
      begin
        cn := ct.Name;
        if UpperCase(cn) = UpperCase(AName) then
        begin
          Result := ct as TTMSWEBStateManagerControl;
          Break;
        end
        else if not Assigned(Result) then
        begin
          {$IFDEF FMXLIB}
          if not (AControl is TCustomForm) then
          {$ENDIF}
            Result := FindControl(ct as TTMSWEBStateManagerControl);
        end;
      end;
    end;
  end;
begin
  Result := nil;
  if Assigned(ARootControl) then
    c := ARootControl
  else
    c := Control;

  if not Assigned(c) then
    Exit;

  Result := FindControl(c);
end;

function TTMSWEBCustomStateManager.GenerateContent: string;
var
  cw: TTMSWEBWriterCustomWritePropertyEvent;
  bl: Boolean;
  sl: TStringList;
  K: Integer;

  procedure AddControls(AControl: TTMSWEBStateManagerControl);
  var
    s: string;
    cn, pn: string;
    ct: TComponent;
    I: Integer;
  begin
    for I := 0 to GetControlCount(AControl) - 1 do
    begin
      ct := GetControls(AControl, I);
      if Assigned(ct) and (ct is TTMSWEBStateManagerControl) then
      begin
        if CanPersist(ct as TTMSWEBStateManagerControl)  then
        begin
          s := ct.ToJSON;
          cn := ct.Name;
          if cn <> '' then
          begin
            pn := '';
            if Assigned((ct as TTMSWEBStateManagerControl).Parent) then
              pn := (ct as TTMSWEBStateManagerControl).Parent.Name;

            sl.Add('{"' + cn + '":{"content":' + s + ', "parent":"' + pn + '"}}');
          end;
        end;

        {$IFDEF FMXLIB}
        if not (AControl is TCustomForm) then
        {$ENDIF}
          AddControls(ct as TTMSWEBStateManagerControl);
      end;
    end;
  end;
begin
  Result := '';
  if not Assigned(Control) then
    Exit;

  cw := TTMSWEBPersistence.OnCustomWriteProperty;
  bl := TTMSWEBCustomControl.BlockPersistenceInterface;
  TTMSWEBPersistence.OnCustomWriteProperty := DoCanWrite;
  TTMSWEBCustomControl.BlockPersistenceInterface := True;
  sl := TStringList.Create;
  try
    sl.Delimiter := ',';
    sl.StrictDelimiter := True;
    sl.LineBreak := '';
    Result := '{"components":[';

    AddControls(Control);

    for K := 0 to sl.Count - 1 do
    begin
      Result := Result + sl[K];
      if K < sl.Count - 1 then
        Result := Result + ','
    end;

    Result := Result + ']}';
  finally
    sl.Free;
    TTMSWEBPersistence.OnCustomWriteProperty := cw;
    TTMSWEBCustomControl.BlockPersistenceInterface := bl;
  end;
end;

function TTMSWEBCustomStateManager.GetDefaultState: TTMSWEBStateManagerItem;
var
  I: Integer;
begin
  Result := nil;
  for I := 0 to States.Count - 1 do
  begin
    if States[I].Default then
    begin
      Result := States[I];
      Break;
    end;
  end;
end;

function TTMSWEBCustomStateManager.GetInstance: NativeUInt;
begin
  Result := HInstance;
end;

function TTMSWEBCustomStateManager.GetControls(
  AControl: TTMSWEBStateManagerControl;
  AIndex: Integer): TTMSWEBStateManagerControl;
begin
  Result := nil;
  {$IFDEF FMXLIB}
  if AControl is TControl then
    Result := (AControl as TControl).Controls[AIndex]
  {$ELSE}
  if AControl is TWinControl then
    Result := (AControl as TWinControl).Controls[AIndex]
  {$ENDIF}
  else if AControl is TCustomForm then
    Result := (AControl as TCustomForm).Controls[AIndex];
end;

function TTMSWEBCustomStateManager.GetControlCount(
  AControl: TTMSWEBStateManagerControl): Integer;
begin
  Result := 0;
  {$IFDEF FMXLIB}
  if AControl is TControl then
    Result := (AControl as TControl).ControlCount
  {$ELSE}
  if AControl is TWinControl then
    Result := (AControl as TWinControl).ControlCount
  {$ENDIF}
  else if AControl is TCustomForm then
    Result := (AControl as TCustomForm).ControlCount;
end;

procedure TTMSWEBCustomStateManager.LoadStateByName(AName: string);
begin
  InternalLoadState(FindStateByName(AName));
end;

procedure TTMSWEBCustomStateManager.LoadStateCustom(
  ACallBack: TTMSWEBStateManagerLoadStateCustomCallback = nil);
var
  I: Integer;
  s: TTMSWEBStateManagerItem;
  b: Boolean;
begin
  for I := 0 to States.Count - 1 do
  begin
    s := States[I];
    b := False;
    if Assigned(ACallBack) then
      ACallBack(s, b)
    else if Assigned(OnLoadStateCustom) then
      OnLoadStateCustom(Self, s, b);

    if b then
    begin
      s.Load;
      Break;
    end;
  end;
end;

procedure TTMSWEBCustomStateManager.Loaded;
begin
  inherited;
  if not IsDesignTime then
    Optimize;
end;

procedure TTMSWEBCustomStateManager.LoadStateByIndex(AIndex: Integer);
begin
  if (AIndex >= 0) and (AIndex <= States.Count - 1) then
    InternalLoadState(States[AIndex]);
end;

procedure TTMSWEBCustomStateManager.InternalSaveToState(
  AState: TTMSWEBStateManagerItem; ANew: Boolean);
begin
  if Assigned(AState) then
  begin
    AState.Content := GenerateContent;
    if ANew then
      InternalSetActiveState(AState);
  end;
end;

procedure TTMSWEBCustomStateManager.InternalSetActiveState(
  AState: TTMSWEBStateManagerItem);
begin
  if Assigned(AState) then
    FActiveState := AState.Index;
end;

procedure TTMSWEBCustomStateManager.InternalLoadState(
  AState: TTMSWEBStateManagerItem);
var
  s: string;
  v, jv, jvv, jvvo, ct: TJSONValue;
  I: Integer;
  nm: string;
  a: TJSONArray;
  c, p: TTMSWEBStateManagerControl;
  bl, cl: Boolean;
  pn: string;
  ie: Boolean;
begin
  if Assigned(AState) and (AState.Index <> FActiveState) then
  begin
    if IsDesignTime then
    begin
      if AutoSave then
        SaveToState(ActiveState);
    end;

    cl := True;
    DoBeforeLoadState(AState, cl);
    if cl then
    begin
      InternalSetActiveState(AState);

      s := AState.Content;
      v := TTMSWEBUtils.ParseJSON(s);
      if Assigned(v) then
      begin
        ie := TTMSWEBPersistence.IgnoreExceptions;
        bl := TTMSWEBCustomControl.BlockPersistenceInterface;
        TTMSWEBCustomControl.BlockPersistenceInterface := True;
        TTMSWEBPersistence.IgnoreExceptions := True;
        try
          jv := TTMSWEBUtils.FindJSONValue(v, 'components');
          if Assigned(jv) and (jv is TJSONArray) then
          begin
            {$IFDEF FMXLIB}
            if Assigned(Control) then
            begin
              if (Control is TControl) then
                (Control as TControl).BeginUpdate
              else if Control is TCustomForm then
                (Control as TCustomForm).BeginUpdate;
            end;
            {$ENDIF}

            {$IFDEF VCLLIB}
            if Assigned(Control) and (Control is TWinControl) then
              TControlOpen(Control).DisableAlign;
            {$ENDIF}

            if Assigned(Control) and IsDesignTime then
              BeforeLoadState(AState);

            try
              a := jv as TJSONArray;
              for I := 0 to TTMSWEBUtils.GetJSONArraySize(a) - 1 do
              begin
                jvv := TTMSWEBUtils.GetJSONArrayItem(a, I);
                if Assigned(jvv) and (jvv is TJSONObject) then
                begin
                  nm := TTMSWEBUtils.GetJSONObjectName(jvv as TJSONObject, 0);
                  c := FindControlByName(nm);
                  if Assigned(c) then
                  begin
                    jvvo := TTMSWEBUtils.GetJSONValue(jvv, nm);
                    if Assigned(jvvo) then
                    begin
                      ct := TTMSWEBUtils.GetJSONValue(jvvo, 'content');
                      pn := TTMSWEBUtils.GetJSONProp(jvvo, 'parent');
                      cl := True;
                      s := TTMSWEBUtils.GetJSONValueAsString(ct);
                      DoBeforeLoadControlState(AState, c, s, cl);
                      if cl then
                      begin
                        if Assigned(ct) and (s <> '') then
                        begin
                          {$IFDEF VCLLIB}
                          //prototype
                          if not IsDesigntime then
                            TTMSWEBUtils.ScaleForDPI(c, DesigntimeFormPixelsPerInch);
                          {$ENDIF}
                          c.FromJSON(s);
                          {$IFDEF VCLLIB}
                          //prototype
                          if not IsDesigntime then
                            TTMSWEBUtils.ScaleForDPI(c, Round(DesigntimeFormPixelsPerInch * TTMSWEBUtils.GetDPIScale(Self, DesigntimeFormPixelsPerInch)));
                          {$ENDIF}
                        end;

                        if pn <> '' then
                        begin
                          p := FindControlByName(pn);
                          if Assigned(p) then
                          begin
                            {$IFNDEF FMXLIB}
                            if p is TWinControl then
                            {$ENDIF}
                              c.Parent := p{$IFNDEF FMXLIB} as TWinControl{$ENDIF};
                          end;
                        end;

                        DoAfterLoadControlState(AState, c, s);
                      end;
                    end;
                  end;
                end;
              end;
            finally
              {$IFDEF FMXLIB}
              if Assigned(Control) then
              begin
                if (Control is TControl) then
                  (Control as TControl).EndUpdate
                else if Control is TCustomForm then
                  (Control as TCustomForm).EndUpdate;
              end;
              {$ENDIF}
              {$IFDEF VCLLIB}
              if Assigned(Control) and (Control is TWinControl) then
                TControlOpen(Control).EnableAlign;
              {$ENDIF}
            end;
          end;
        finally
          v.Free;
          TTMSWEBCustomControl.BlockPersistenceInterface := bl;
          TTMSWEBPersistence.IgnoreExceptions := ie;
        end;
      end;

      DoAfterLoadState(AState);
    end;
  end;
end;

procedure TTMSWEBCustomStateManager.Optimize;
var
  L: Integer;
  ov, jvv, jov, jovsub: TJSONValue;
  ja: TJSONArray;
  o: TTMSWEBStateManagerRootJSONValue;
  oarr: TTMSWEBStateManagerRootJSONValueList;
  arr: TTMSWEBStateManagerJSONValueList;
  I: Integer;
  nm: string;
  M: Integer;

  function CompareValues(va: TTMSWEBStateManagerJSONValueArray): Boolean;
  var
    K: Integer;
    v: string;
    s: string;
  begin
    Result := False;
    if Length(va) > 0 then
    begin
      v := TTMSWEBUtils.GetJSONValueAsString(va[0]);
      s := v;
      for K := 1 to Length(va) - 1 do
      begin
        s := s + ', ' + TTMSWEBUtils.GetJSONValueAsString(va[K]);
        if TTMSWEBUtils.GetJSONValueAsString(va[K]) <> v then
        begin
          Result := True;
          Break;
        end;
      end;
    end;
  end;

  procedure CompareObjects(oa: TTMSWEBStateManagerJSONValueList; ARoot: Boolean);
  var
    J, {P, }K: Integer;
    jv{, a}: TJSONValue;
    v: TJSONValue;
    sz: Integer;
    oasub: TTMSWEBStateManagerJSONValueList;
    vasub: TTMSWEBStateManagerJSONValueArray;
    n: string;
    {$IFNDEF LCLLIB}
    pr: TJSONPair;
    {$ENDIF}
    sl: TStringList;
  begin
    if oa.Count > 0 then
    begin
      v := oa[0].FValue;
      if v is TJSONObject then
      begin
        sz := TTMSWEBUtils.GetJSONObjectSize(v as TJSONObject);
        sl := TStringList.Create;
        try
          for k := 0 to sz - 1 do
          begin
            n := TTMSWEBUtils.GetJSONObjectName(v as TJSONObject, k);
            sl.Add(n);
          end;

          for k := 0 to sl.Count - 1 do
          begin
            jv := TTMSWEBUtils.GetJSONValue(v, sl[k]);
            n := sl[k];

            oasub := TTMSWEBStateManagerJSONValueList.Create;
            try
              oasub.Add(TTMSWEBStateManagerJSONValue.Create(v, jv, n));
              for J := 1 to oa.Count - 1 do
                oasub.Add(TTMSWEBStateManagerJSONValue.Create(oa[J].FValue, TTMSWEBUtils.GetJSONValue(oa[J].FValue, n), n));

              CompareObjects(oasub, False);

            finally
              oasub.Free;
            end;
          end
        finally
          sl.Free;
        end;

        if not ARoot then
        begin
          for J := 0 to oa.Count - 1 do
          begin
            if TTMSWEBUtils.GetJSONValueAsString(oa[J].FValue) = '{}' then
            begin
              if oa[J].FParentValue is TJSONObject then
              begin
                {$IFDEF LCLLIB}
                (oa[J].FParentValue as TJSONObject).Delete(oa[J].FValueName);
                {$ELSE}
                pr := (oa[J].FParentValue as TJSONObject).RemovePair(oa[J].FValueName);
                if Assigned(pr) then
                  pr.Free;
                {$ENDIF}
              end;
            end;
          end;
        end;
      end
//      else if v is TJSONArray then
//      begin
//        for P := 0 to TTMSWEBUtils.GetJSONArraySize((v as TJSONArray)) - 1 do
//        begin
//          a := TTMSWEBUtils.GetJSONArrayItem((v as TJSONArray), P);
//
//          oasub := TTMSWEBStateManagerJSONValueList.Create;
//          try
//            oasub.Add(TTMSWEBStateManagerJSONValue.Create(v, a, ''));
//            for J := 1 to oa.Count - 1 do
//              oasub.Add(TTMSWEBStateManagerJSONValue.Create(oa[J].FValue, TTMSWEBUtils.GetJSONArrayItem((oa[J].FValue as TJSONArray), P), ''));
//
//            CompareObjects(oasub, False);
//
//          finally
//            oasub.Free;
//          end;
//        end;
//      end
      else if (v is TJSONValue) and not ARoot then
      begin
        SetLength(vasub, oa.Count);
        vasub[0] := v;
        for J := 1 to oa.Count - 1 do
          vasub[J] := oa[J].FValue;

        if not CompareValues(vasub) then
        begin
          for J := 0 to oa.Count - 1 do
          begin
            if oa[J].FParentValue is TJSONObject then
            begin
              {$IFDEF LCLLIB}
              (oa[J].FParentValue as TJSONObject).Delete(oa[J].FValueName);
              {$ELSE}
              pr := (oa[J].FParentValue as TJSONObject).RemovePair(oa[J].FValueName);
              if Assigned(pr) then
                pr.Free;
              {$ENDIF}
            end;
          end;
        end;
      end;
    end;
  end;

begin
  oarr := TTMSWEBStateManagerRootJSONValueList.Create;
  try
    for L := 0 to States.Count - 1 do
    begin
      ov := TTMSWEBUtils.ParseJSON(States[L].Content);
      if Assigned(ov) then
      begin
        o := TTMSWEBStateManagerRootJSONValue.Create(States[L], ov);
        oarr.Add(o);
      end;
    end;

    if oarr.Count > 0 then
    begin
      jov := TTMSWEBUtils.FindJSONValue(oarr[0].FValue, 'components');
      if Assigned(jov) and (jov is TJSONArray) then
      begin
        ja := jov as TJSONArray;
        for I := 0 to TTMSWEBUtils.GetJSONArraySize(ja) - 1 do
        begin
          jvv := TTMSWEBUtils.GetJSONArrayItem(ja, I);
          if Assigned(jvv) and (jvv is TJSONObject) then
          begin
            nm := TTMSWEBUtils.GetJSONObjectName(jvv as TJSONObject, 0);
            arr := TTMSWEBStateManagerJSONValueList.Create;
            try
              arr.Add(TTMSWEBStateManagerJSONValue.Create(jov, jvv, nm));
              for M := 1 to oarr.Count - 1 do
              begin
                jovsub := TTMSWEBUtils.FindJSONValue(oarr[M].FValue, 'components');
                if Assigned(jovsub) and (jovsub is TJSONArray) then
                  arr.Add(TTMSWEBStateManagerJSONValue.Create(jovsub, TTMSWEBUtils.GetJSONArrayItem(jovsub as TJSONArray, I), nm));
              end;

              CompareObjects(arr, True);

            finally
              arr.Free;
            end;
          end;
        end;
      end;

      for M := 0 to oarr.Count - 1 do
      begin
        if Assigned(oarr[M].FState) then
          oarr[M].FState.Content := TTMSWEBUtils.GetJSONValueAsString(oarr[M].FValue);
      end;
    end;
  finally
    oarr.Free;
  end;
end;

procedure TTMSWEBCustomStateManager.ResetState;
begin
  FActiveState := -1;
end;

procedure TTMSWEBCustomStateManager.SaveToState(
  AState: TTMSWEBStateManagerItem);
begin
  InternalSaveToState(AState, False)
end;

procedure TTMSWEBCustomStateManager.SaveToState(AIndex: Integer);
begin
  if (AIndex >= 0) and (AIndex <= States.Count - 1) then
    SaveToState(States[AIndex]);
end;

procedure TTMSWEBCustomStateManager.SaveToState(AName: string);
begin
  SaveToState(FindStateByName(AName));
end;

procedure TTMSWEBCustomStateManager.SetActiveState(const Value: Integer);
begin
  if FActiveState <> Value then
  begin
    LoadStateByIndex(Value);
    FActiveState := Value;
  end;
end;

procedure TTMSWEBCustomStateManager.SetControl(
  const Value: TTMSWEBStateManagerControl);
begin
  if FControl <> Value then
  begin
    BeforeAssignControl;
    FControl := Value;
    AfterAssignControl;
  end;
end;

procedure TTMSWEBCustomStateManager.SetStates(
  const Value: TTMSWEBStateManagerItems);
begin
  FStates.Assign(Value);
end;

{ TTMSWEBStateManagerItems }

{$IFDEF LCLLIB}
function TTMSWEBStateManagerItems.QueryInterface({$IFDEF FPC_HAS_CONSTREF}constref{$ELSE}const{$ENDIF} iid : tguid;out obj) : longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
{$ELSE}
function TTMSWEBStateManagerItems.QueryInterface(const IID: TGUID; out Obj): HResult;
{$ENDIF}
const
  E_NOINTERFACE = HResult($80004002);
begin
  if GetInterface(IID, Obj) then Result := 0 else Result := E_NOINTERFACE;
end;

{$IFDEF LCLLIB}
function TTMSWEBStateManagerItems._AddRef: longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
{$ELSE}
function TTMSWEBStateManagerItems._AddRef: Integer;
{$ENDIF}
begin
  if FOwnerInterface <> nil then
    Result := FOwnerInterface._AddRef else
    Result := -1;
end;

{$IFDEF LCLLIB}
function TTMSWEBStateManagerItems._Release: longint;{$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
{$ELSE}
function TTMSWEBStateManagerItems._Release: Integer;
{$ENDIF}
begin
  if FOwnerInterface <> nil then
    Result := FOwnerInterface._Release else
    Result := -1;
end;

function TTMSWEBStateManagerItems.Add: TTMSWEBStateManagerItem;
begin
  Result := TTMSWEBStateManagerItem(inherited Add);
end;

constructor TTMSWEBStateManagerItems.Create(AOwner: TTMSWEBCustomStateManager);
begin
  inherited Create(AOwner, GetStateManagerStateClass);
  FOwner := AOwner;
end;

function TTMSWEBStateManagerItems.CreateObject(const AClassName: string;
  const ABaseClass: TClass): TObject;
begin
  Result := GetStateManagerStateClass.Create(nil);
end;

function TTMSWEBStateManagerItems.GetInterfaceItemClass: TClass;
begin
  Result := GetStateManagerStateClass;
end;

function TTMSWEBStateManagerItems.GetStateManagerStateClass: TCollectionItemClass;
begin
  Result := TTMSWEBStateManagerItem;
end;

function TTMSWEBStateManagerItems.GetItemEx(Index: Integer): TTMSWEBStateManagerItem;
begin
  Result := TTMSWEBStateManagerItem(inherited Items[Index]);
end;

function TTMSWEBStateManagerItems.Insert(index: Integer): TTMSWEBStateManagerItem;
begin
  Result := TTMSWEBStateManagerItem(inherited Insert(Index));
end;

procedure TTMSWEBStateManagerItems.SetItemEx(Index: Integer; const Value: TTMSWEBStateManagerItem);
begin
  inherited SetItem(Index, Value);
end;

{ TTMSWEBStateManagerItem }

procedure TTMSWEBStateManagerItem.Assign(Source: TPersistent);
begin
  if (Source is TTMSWEBStateManagerItem) then
  begin
    FName := (Source as TTMSWEBStateManagerItem).Name;
    FContent := (Source as TTMSWEBStateManagerItem).Content;
    FDefault := (Source as TTMSWEBStateManagerItem).Default;
  end;
end;

constructor TTMSWEBStateManagerItem.Create(Collection: TCollection);
var
  m: TTMSWEBCustomStateManager;
begin
  inherited;

  if Assigned(Collection) and Assigned((Collection as TTMSWEBStateManagerItems).FOwner) then
    FOwner := (Collection as TTMSWEBStateManagerItems).FOwner;

  m := Manager;
  FDefault := False;
  FContent := '';

  if Assigned(m) and m.IsDesignTime then
  begin
    if Collection.Count = 1 then
      FDefault := True;

    FName := 'State ' + IntToStr(Collection.Count);

    m.InternalSaveToState(Self, True);
  end;
end;

destructor TTMSWEBStateManagerItem.Destroy;
begin
  inherited;
end;

function TTMSWEBStateManagerItem.GetDisplayName: string;
begin
  if FName <> '' then
    Result := FName
  {$IFDEF WEBLIB}
  else
    Result := '';
  {$ENDIF}
  {$IFNDEF WEBLIB}
  else
    Result := inherited;
  {$ENDIF}
end;

function TTMSWEBStateManagerItem.GetName: string;
begin
  Result := FName;
  if Result = '' then
    Result := 'State ' + IntToStr(Index + 1);
end;

procedure TTMSWEBStateManagerItem.Load;
var
  m: TTMSWEBCustomStateManager;
begin
  m := Manager;
  if Assigned(m) then
    m.InternalLoadState(Self);
end;

function TTMSWEBStateManagerItem.Manager: TTMSWEBCustomStateManager;
begin
  Result := FOwner;
end;

procedure TTMSWEBStateManagerItem.SetDefault(const Value: Boolean);
var
  I: Integer;
  m: TTMSWEBCustomStateManager;
begin
  if FDefault <> Value then
  begin
    m := Manager;
    if Assigned(m) and not m.IsLoading then
    begin
      for I := 0 to m.States.Count - 1 do
        m.States[I].FDefault := False;
    end;

    FDefault := Value;
  end;
end;

{ TTMSWEBStateManagerRootJSONValue }

constructor TTMSWEBStateManagerRootJSONValue.Create(
  AState: TTMSWEBStateManagerItem; AValue: TJSONValue);
begin
  FState := AState;
  FValue := AValue;
end;

destructor TTMSWEBStateManagerRootJSONValue.Destroy;
begin
  FreeAndNil(FValue);
  FState := nil;
  inherited;
end;

constructor TTMSWEBStateManagerJSONValue.Create(AParentValue, AValue: TJSONValue; AValueName: string);
begin
  FValue := AValue;
  FParentValue := AParentValue;
  FValueName := AValueName;
end;

destructor TTMSWEBStateManagerJSONValue.Destroy;
begin
  FValue := nil;
  FParentValue := nil;
  FValueName := '';
  inherited;
end;

end.
